/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_159_TitleInputs */

const en_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bald Cypress`)
};

const ar_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شجرة السرو الأصلع`)
};

const de_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumpfzypresse`)
};

const es_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciprés calvo`)
};

const fr_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cyprès Chauve`)
};

const it_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipresso Calvo`)
};

const ja_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラクウショウ`)
};

const ko_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`낙우송`)
};

const pt_br_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinheiro-do-Brejo`)
};

const ru_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таксодиум двурядный`)
};

const th_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนหัวโล้น`)
};

const tr_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bataklık Selvisi`)
};

const zh_cn_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落羽杉`)
};

const zh_tw_tree_type_159_title = /** @type {(inputs: Tree_Type_159_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落羽松`)
};

/**
* | output |
* | --- |
* | "Bald Cypress" |
*
* @param {Tree_Type_159_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_159_title = /** @type {((inputs?: Tree_Type_159_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_159_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_159_title(inputs)
	if (locale === "ar") return ar_tree_type_159_title(inputs)
	if (locale === "de") return de_tree_type_159_title(inputs)
	if (locale === "es") return es_tree_type_159_title(inputs)
	if (locale === "fr") return fr_tree_type_159_title(inputs)
	if (locale === "it") return it_tree_type_159_title(inputs)
	if (locale === "ja") return ja_tree_type_159_title(inputs)
	if (locale === "ko") return ko_tree_type_159_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_159_title(inputs)
	if (locale === "ru") return ru_tree_type_159_title(inputs)
	if (locale === "th") return th_tree_type_159_title(inputs)
	if (locale === "tr") return tr_tree_type_159_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_159_title(inputs)
	return zh_tw_tree_type_159_title(inputs)
});